export class Constants {
    static JWT_TOKEN_NAME: string = 'jwt_token';
    static JWT_IDTOKEN_NAME: string = 'id_token';
    static JWT_ACCESSTOKEN_NAME: string = 'access_token';
    static JWT_REFRESHTOKEN_NAME: string = 'refresh_token';

    static FORMATOPTIONS_CURRENCY: any = {
        style: 'currency',
        currency: 'EUR',
        currencyDisplay: 'symbol'
    };

    static TELEPHONE_VALIDATION_REGEXP: string = '^[+]\\d{2}\\s\\d+\\s(\\d+)$';
    static EMAIL_VALIDATION_REGEXP: string = '^(([^<>()[\\]\\\\.,;:\\s@\\\"]+(\\.[^<>()[\\]\\\\.,;:\\s@\\\"]+)*)|(\\\".+\\\"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$';
}



// WEBPACK FOOTER //
// ./src/app/shared/constants.ts